export interface IWidgetPositionConfig {
  POSITION_X_OFFSET_MENU_RIGHT: number;
  POSITION_X_OFFSET_MENU_LEFT_SIDE: number;
  POSITION_X_OFFSET_MENU_INDICATOR_START: number;
  POSITION_Y_OFFSET_MENU_RIGHT: number;
  POSITION_Y_OFFSET_MENU_LEFT_SIDE: number;
  POSITION_Y_OFFSET_MENU_INDICATOR_START: number;
  MINIMAL_POSITION_Y_OFFSET: number;
}

export const CONFIG = {
  POSITION_X_OFFSET_MENU_RIGHT: -40.0,
  POSITION_X_OFFSET_MENU_LEFT_SIDE: 160.0,
  POSITION_X_OFFSET_MENU_INDICATOR_START: 0.0,
  POSITION_Y_OFFSET_MENU_RIGHT: -475.0,
  POSITION_Y_OFFSET_MENU_LEFT_SIDE: -10.0,
  POSITION_Y_OFFSET_MENU_INDICATOR_START: -270.0,
  MINIMAL_POSITION_Y_OFFSET: -190.0,
} as IWidgetPositionConfig;
